export function isNullOrEmpty(str: String): boolean {
  return !str || str.length === 0;
}

export function isDefined(obj: any): boolean {
  return obj !== undefined;
}
